if (!customElements.get('cc-safety')) {
  customElements.define(
    'cc-safety',
    class extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-cc-safety-trigger]'));
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => this.handleClick(e));
        });
      }

      handleClick(event) {
        const trigger = event.currentTarget;
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        this.triggers.forEach((t) => {
          if (t === trigger) return;
          t.setAttribute('aria-expanded', 'false');
          t.closest('.cc-safety__row')?.classList.remove('is-open');
          const otherBodyId = t.getAttribute('aria-controls');
          const otherBody = otherBodyId ? this.querySelector('#' + otherBodyId) : null;
          if (otherBody) otherBody.hidden = true;
        });

        const nextOpen = !isOpen;
        trigger.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        trigger.closest('.cc-safety__row')?.classList.toggle('is-open', nextOpen);
        const bodyId = trigger.getAttribute('aria-controls');
        const body = bodyId ? this.querySelector('#' + bodyId) : null;
        if (body) body.hidden = !nextOpen;
      }
    }
  );
}
